import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Domain } from '../models/domain';

@Injectable({ providedIn: 'root' })
export class DomainService {
  private readonly domains: Observable<Domain[]>;

  constructor(private readonly httpClient: HttpClient) {
    this.domains = this.httpClient.get<Domain[]>(`${environment.ApiEndpoint}/Domain/GetDomains`, this.createHeader())
      .pipe(shareReplay({ bufferSize: 1, refCount: true }));
  }

  getDomains(): Observable<Domain[]> {
    return this.domains;
  }

  private createHeader() {
    return { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  }
}
